import { render, staticRenderFns } from "./DetailedTable.vue?vue&type=template&id=5c759c10&scoped=true"
import script from "./DetailedTable.vue?vue&type=script&lang=js"
export * from "./DetailedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c759c10",
  null
  
)

export default component.exports